import { gallerySectionOne } from "../../data/gallerySection";
import useActive from "../../hooks/useActive";
import { Link } from "react-router-dom";
import React, { useState } from "react";
import Masonry from "react-masonry-css";
import GalleryItem from "./GalleryItem";

const masonryBreakpoints = {
  default: 3,
  1100: 2,
  700: 1,
};

const { title, tabBtns, items } = gallerySectionOne;

const getCurrentItems = (current = "") =>
  items.filter((it) => it.filter.includes(current));

const getCount = (current = "") => getCurrentItems(current).length;

const GallerySectionOne = ({ portfolio = false, similar = false }) => {
  const [current, setCurrent] = useState("all");
  const currentItems = getCurrentItems(current);
  const ref = useActive("#portfolio");

  return (
    <section
      ref={ref}
      className={`gallery-section${similar ? " similar-gallery" : ""}`}
      id="portfolio"
    >
      <div className="auto-container">
        <div className="mixitup-gallery">
          <div className={portfolio || similar ? "" : "upper-row clearfix"}>
            {!portfolio && (
              <div className={`sec-title${similar ? " centered" : ""}`}>
                <h2>
                  {similar ? "Similar work " : title}
                  <span className="dot">.</span>
                </h2>
              </div>
            )}
            {!similar && (
              <div
                className={`filters clearfix${portfolio ? " centered" : ""}`}
              >
                <ul className="filter-tabs filter-btns clearfix">
                  {tabBtns.map(({ id, name, tab }) => (
                    <li
                      onClick={() => setCurrent(tab)}
                      key={id}
                      className={`${current === tab ? "active " : ""}filter`}
                      data-role="button"
                    >
                      {name}
                      <sup>[{getCount(tab)}]</sup>
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          <Masonry
            breakpointCols={masonryBreakpoints}
            className="masonry-grid"
            columnClassName="masonry-grid_column"
          >
            {currentItems.slice(similar ? 3 : 0).map((item) => (
              <GalleryItem item={item} key={item.id} />
            ))}
          </Masonry>
          {portfolio && (
            <div className="more-box">

              <Link to="/portfolio" className="theme-btn btn-style-one">
                <i className="btn-curve"></i>
                <span className="btn-title">Load more work</span>
              </Link>

            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default GallerySectionOne;
